var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 176,
    viewBox: "0 0 260 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8623_8718)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -125,
    cy: 365,
    r: 384.75,
    fill: "#B4EDE3",
    stroke: "#BFBFBF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -174,
    cy: 345,
    r: 384.75,
    fill: "#F7DFE3",
    stroke: "#BFBFBF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -233,
    cy: 307,
    r: 384.75,
    fill: "#EBF6FE",
    stroke: "#BFBFBF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -292,
    cy: 251,
    r: 384.75,
    fill: "#E5F8EC",
    stroke: "#BFBFBF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -332,
    cy: 196,
    r: 384.75,
    fill: "#EBDFF6",
    stroke: "#BFBFBF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: -362,
    cy: 132,
    r: 384.75,
    fill: "#FDF5B4",
    stroke: "#BFBFBF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8623_8718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 176,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.da97bb4e9dcbac7bf3cb377c2230c505.svg";
export { ForwardRef as ReactComponent };